var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommenticon = function SvgCommenticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.1 10.736h5.6a.4.4 0 0 0 .4-.4v-.8a.4.4 0 0 0-.4-.4H4.1a.4.4 0 0 0-.4.4v.8c0 .221.18.4.4.4Zm7.8-3.2H4.1a.4.4 0 0 1-.4-.4v-.8c0-.22.18-.4.4-.4h7.8a.4.4 0 0 1 .4.4v.8a.4.4 0 0 1-.4.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0a8 8 0 0 0-8 8v8h8A8 8 0 1 0 8 0Zm0 1.6A6.4 6.4 0 0 0 1.6 8v6.4H8A6.4 6.4 0 0 0 8 1.6Z",
    clipRule: "evenodd"
  })));
};
export default SvgCommenticon;